import React from "react";

function OrderBoxIcon({
  stroke = "white",
  strockWidth = "1.2",
  height = "20",
}) {
  return (
    <svg
      width="20"
      height={height}
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6 4.60156V18.6016C18.6 19.132 18.3893 19.6407 18.0142 20.0158C17.6391 20.3908 17.1304 20.6016 16.6 20.6016H2.6C2.06957 20.6016 1.56086 20.3908 1.18578 20.0158C0.810712 19.6407 0.599998 19.132 0.599998 18.6016V4.60156L3.6 0.601562H15.6L18.6 4.60156ZM0.599998 4.60156H18.6M13.6 8.60156C13.6 9.66243 13.1786 10.6798 12.4284 11.43C11.6783 12.1801 10.6609 12.6016 9.6 12.6016C8.53913 12.6016 7.52172 12.1801 6.77157 11.43C6.02143 10.6798 5.6 9.66243 5.6 8.60156"
        stroke={stroke}
        strokeWidth={strockWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default OrderBoxIcon;
